import { useEffect, useState } from 'react'
import { useIdleTimer } from 'react-idle-timer'
import { Modal, Result } from 'antd';
import { Navigate } from 'react-router-dom'


export default function SessionTimeout() {
    const [state, setState] = useState('Active')
    const [remaining, setRemaining] = useState(0)
    const [count, setCount] = useState(0)
    const [open, setOpen] = useState(false)
    const [logout, setLogout] = useState(false)
    const onIdle = () => {
        setState('Idle')
    }

    const onActive = () => {
        setState('Active')
    }

    const onPrompt = () => {
        setState('Prompted')
        setOpen(true)
    }

    const onMessage = (e) => {
        if(e==="logout") {
            setLogout(true)
        }
        setCount(count + 1)
    }

    const {
        getRemainingTime,
        activate,
        message
    } = useIdleTimer({
        onIdle,
        onActive,
        onPrompt,
        onMessage,
        timeout: 7200_000,
        throttle: 500,
        promptBeforeIdle: 300_000,
        crossTab: true,
        leaderElection: true,
        syncTimers: 200
    })

    useEffect(() => {
        const interval = setInterval(() => {
            setRemaining(Math.ceil(getRemainingTime() / 1000))
        }, 500)

        return () => {
            clearInterval(interval)
        }
    })


    const activiteHandle = () => {
        activate()
        setOpen(false)
    }

    const logoutHandle = () => {
        setLogout(true)
        message('logout', true)
    }


    if (logout || state === "Idle") {
        return (
            <Navigate to="/Logout" />
        );
    } else {

        return (
            <>



                <div className='w-100 position-absolute text-white bg-info text-center'  style={{
                    bottom: "0",
                    display:"none"

                }}>
                    <p className='mb-0'><small style={{fontSize:"9px"}}>{remaining}</small></p>

                    <Modal

                        open={open}
                        onOk={activiteHandle}
                        onCancel={logoutHandle}
                        footer={false}
                        maskClosable={false}
                        closeIcon={false}
                        styles={{
                            content:{
                                padding:"0px"
                            }
                        }}
                        okText="Continue working"
                        cancelText="Logout now"
                    >
                        <Result
                            title="Your session has been executed"
                            extra={
                                <div className='row'>
                                    <div className='col-md-12'>
                                        <p>Your session will expire in <b>{remaining}</b> seconds. <br></br>Press the <b>'Continue working'</b> button to stay in the system.</p>
                                    </div>
                                    <div className='col-md-12 mt-3'>
                                        <button style={{ minWidth:"320px"}} onClick={activiteHandle} className='btn btn-primary'>
                                            Continue working
                                        </button>
                                    </div>
                                    <div className='col-md-12 mt-2'>
                                        <button style={{ minWidth:"320px"}} onClick={logoutHandle} className='btn btn-warning'>
                                            Logout now
                                        </button>
                                    </div>
                                </div>

                            }
                        />
                    </Modal>

                </div>




            </>
        )
    }

}
